const initRewardsProductCarouselSwiper = (root) => {
  if (typeof window.Swiper !== 'function') return;
  if (!root) return;

  const swiperEl = root.querySelector('.rewards-product-carousel__swiper');
  if (!swiperEl || swiperEl.classList.contains('swiper-initialized')) return;

  const wrap = swiperEl.closest('.rewards-product-carousel__swiper-wrap');
  if (!wrap) return;

  const prevEl = wrap.querySelector('.rewards-product-carousel__arrow--prev');
  const nextEl = wrap.querySelector('.rewards-product-carousel__arrow--next');
  const paginationEl = wrap.querySelector('.rewards-product-carousel__pagination');

  const instance = new Swiper(swiperEl, {
    slidesPerView: 2.2,
    slidesPerGroup: 1,
    spaceBetween: 20,
    centeredSlides: false,
    loop: false,
    breakpoints: {
      750: {
        slidesPerView: 4,
        spaceBetween: 30
      }
    },
    navigation:
      prevEl && nextEl
        ? {
            nextEl,
            prevEl
          }
        : false,
    pagination:
      paginationEl
        ? {
            el: paginationEl,
            clickable: true
          }
        : false,
    on: {
      init() {
        swiperEl.classList.add('swiper-initialized');
      }
    }
  });

  // Store instance if needed later
  swiperEl._rewardsProductCarouselSwiper = instance;
};

// Initial load: init every Rewards Product Carousel section on the page.
document.addEventListener('DOMContentLoaded', () => {
  const roots = document.querySelectorAll('.rewards-product-carousel[data-section-id]');
  roots.forEach((root) => initRewardsProductCarouselSwiper(root));
});

// Theme editor / dynamic reloads: initialize for the specific section that was loaded.
document.addEventListener('shopify:section:load', (event) => {
  if (event.target.matches('.rewards-product-carousel[data-section-id]')) {
    initRewardsProductCarouselSwiper(event.target);
  }
});
